import React from "react";
import RefreshButton from "../../common/RefreshButton";
import { useTranslation } from "../../../../i18n/LanguageContext";

function UserListControls({ refreshing, loading, onRefresh, userCount }) {
  const { t } = useTranslation();

  return (
    <div className="um-roster-controls-refresh">
      <span className="um-roster-controls-title">
        {t("usermgmt.controls.userListLabel")}
      </span>
      <RefreshButton
        onClick={onRefresh}
        loading={refreshing}
        disabled={loading}
        title={t("usermgmt.controls.refreshTitle")}
      />
    </div>
  );
}

export default UserListControls;
